module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Physitrack")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.requests.get.loading) ? _c('v-card-text', [_c('center', [_c('v-progress-circular', {
    staticClass: "ma-4 pa-4",
    attrs: {
      "indeterminate": "",
      "color": "amber",
      "width": "3",
      "size": "36"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n          Loading\n        ")], 1)], 1) : [(!_vm.physitrackClientId) ? [_c('v-alert', {
    staticClass: "ma-3",
    attrs: {
      "value": true,
      "type": "info",
      "outline": "",
      "outlined": ""
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.relationshipFirstName) + " " + _vm._s(_vm.relationshipLastName) + "\n              "), (_vm.dob) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.dob)
    }
  }) : _vm._e()]), _c('br'), _vm._v("\n            User does not exist in Physitrack. Would you like to create a user?\n            "), _c('request-status', {
    attrs: {
      "request": _vm.requests.create
    }
  }), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.isValid),
      callback: function($$v) {
        _vm.isValid = $$v
      },
      expression: "isValid"
    }
  }, [_c('v-layout', {
    staticClass: "mt-2"
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "rules": [_vm.rules.required, _vm.rules.validDate],
      "hint": "Date of birth is required by Physitrack and the user will use the _year_ to log in to physitrack",
      "persistent-hint": true,
      "error-messages": _vm.createClientErrors.date_of_birth,
      "placeholder": "yyyy-mm-dd",
      "label": "Date of birth (yyyy-mm-dd)"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.create.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.date_of_birth),
      callback: function($$v) {
        _vm.date_of_birth = $$v
      },
      expression: "date_of_birth"
    }
  }), _vm._v(" "), _c('small', [_c('strong', [_vm._v("TIP:")]), _vm._v("\n                  if you do not know the date of birth, you can make something up. But try get the year right if you can\n                ")])], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    attrs: {
      "disabled": !_vm.isValid,
      "loading": _vm.requests.create.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Or, link to an existing client in Physitrack")])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-text-field', {
    staticClass: "ma-3",
    attrs: {
      "persistent-hint": "",
      "loading": _vm.requests.clients.loading,
      "label": "Look for a client in Physitrack",
      "hint": "Search the last name of a client in Physitrack (note: search is case sensitive and must be an exact match)",
      "append-icon": "search"
    },
    on: {
      "click:append": function($event) {
        return _vm.getClients(_vm.lastName)
      },
      "keypress": _vm.debounceSearch
    },
    model: {
      value: (_vm.lastName),
      callback: function($$v) {
        _vm.lastName = $$v
      },
      expression: "lastName"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "small": "",
      "loading": _vm.requests.clients.loading
    },
    on: {
      "click": function($event) {
        return _vm.getClients(_vm.lastName)
      }
    }
  }, [_vm._v("Search")])], 1)], 1), _vm._v(" "), (_vm.requests.clients.status === 200) ? [(_vm.clients && _vm.clients.length > 0) ? _c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n                Matches found\n              ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, _vm._l((_vm.clients), function(client, index) {
    return _c('physitrack-client-list-item', {
      key: client.id,
      model: {
        value: (_vm.clients[index]),
        callback: function($$v) {
          _vm.$set(_vm.clients, index, $$v)
        },
        expression: "clients[index]"
      }
    }, [_c('v-list-tile-action', {
      attrs: {
        "slot": "action"
      },
      slot: "action"
    }, [_c('v-btn', {
      attrs: {
        "loading": _vm.requests.link.loading,
        "color": "primary",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.link(client.id)
        }
      }
    }, [_vm._v("Link")])], 1)], 1)
  }), 1)], 1)], 1) : _c('v-alert', {
    staticClass: "pa-0 mx-3",
    attrs: {
      "value": true,
      "outline": "",
      "type": "info"
    }
  }, [_vm._v("\n              No clients found with surname "), _c('strong', [_vm._v(_vm._s(_vm.lastName))])])] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.physitrackClientId && _vm.relationshipId) ? _c('programs', {
    attrs: {
      "physitrack-client-id": _vm.physitrackClientId,
      "relationship-id": _vm.relationshipId,
      "touch": _vm.physiTouch
    },
    model: {
      value: (_vm.physitrackClient),
      callback: function($$v) {
        _vm.physitrackClient = $$v
      },
      expression: "physitrackClient"
    }
  }) : _vm._e()]], 2)], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.visible = true
      }
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("expand_more")])], 1), _vm._v("\n    Physitrack\n  ")], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f4eb7c0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Physitrack/PhysitrackEmbed.vue
// module id = 1494
// module chunks = 9